import { QRCodeSVG } from "qrcode.react";
import { Button } from "../ui/button";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

type Props = {
  secret: string;
  uri: string;
  code: string;
  onCodeChange: (code: string) => void;
  onConfirm: () => void;
  confirming: boolean;
  disabled: boolean;
};

export function TotpEnrollment({ secret, uri, code, onCodeChange, onConfirm, confirming, disabled }: Props) {
  return (
    <form className="space-y-4 rounded-md border border-border/60 bg-muted/40 p-4" onSubmit={(event) => { event.preventDefault(); if (!disabled && code.trim()) onConfirm(); }}>
      {uri ? (
        <div className="space-y-3">
          <p id="totp-scan-help" className="text-sm text-muted-foreground">
            Scan this code with your authenticator app, then enter its verification code below.
          </p>
          <div className="mx-auto w-fit max-w-full rounded-md bg-white p-2">
            <QRCodeSVG
              value={uri}
              size={224}
              level="M"
              marginSize={4}
              bgColor="#FFFFFF"
              fgColor="#000000"
              title="IO Spoke authenticator setup"
              role="img"
              aria-label="Authenticator setup QR code"
              aria-describedby="totp-scan-help"
              className="h-auto max-w-full"
            />
          </div>
        </div>
      ) : null}
      <div className="space-y-2">
        <Label htmlFor="totp-secret">Secret key</Label>
        <Input id="totp-secret" readOnly autoComplete="off" value={secret} aria-describedby="totp-manual-help" />
        <p id="totp-manual-help" className="text-xs text-muted-foreground">
          Cannot scan? Add this key manually in your authenticator app for IO Spoke.
        </p>
      </div>
      <div className="space-y-2">
        <Label htmlFor="totp-code">Enter verification code</Label>
        <Input id="totp-code" inputMode="numeric" autoComplete="one-time-code" placeholder="123456" value={code} disabled={disabled} onChange={(event) => onCodeChange(event.target.value)} />
      </div>
      <Button loading={confirming} loadingLabel="Verifying code…" type="submit" disabled={disabled || !code.trim()}>
        Confirm 2FA setup
      </Button>
    </form>
  );
}
